import axios from 'axios';
import api, { baseURL } from '../../../services/api/api';
import { Budget } from '../../../@types/budget';

export const getBudgetData = async (budgetId: string) => {
  const { data } = await axios.get<Budget>(`${baseURL}budget/${budgetId}`);
  return data;
};

export const getBudgetPdfURL = async (orderServiceId: string) => {
  const { data } = await api.get<{
    fileUrl: string;
  }>(`/pdf/budget/${orderServiceId}`);
  return data;
};
